// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-unit-menu__list li{padding:13px!important;font-size:13px!important;line-height:1.1;cursor:pointer;transition:.2s}.m-unit-menu__list li:hover{background:#f8f8f8}", ""]);
// Exports
module.exports = exports;
